import { render, staticRenderFns } from "./DoctorPrescription.vue?vue&type=template&id=033988e4&scoped=true"
import script from "./DoctorPrescription.vue?vue&type=script&lang=js"
export * from "./DoctorPrescription.vue?vue&type=script&lang=js"
import style0 from "./DoctorPrescription.vue?vue&type=style&index=0&id=033988e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033988e4",
  null
  
)

export default component.exports